import { Injectable } from '@angular/core';
import { oofDtos } from '@vectronic/openApi-customer';

@Injectable({ providedIn: 'root' })
export class OofHelperService {
  addressesNotSet(order: oofDtos.Order) {
    return !(
      order.invoiceAddress &&
      (order.deliveryAddress || order.deliverySameAsInvoiceAddress) &&
      order.paymentMethod
    );
  }
}
